import { Controller } from "@hotwired/stimulus";

// A tab bar that overflows scrolls horizontally, which can leave the selected tab out of view.
export default class UIActiveTabController extends Controller {
  static targets = ["active"];

  connect() {
    if (!this.hasActiveTarget) return;

    const overflow = this.activeTarget.getBoundingClientRect().right - this.element.getBoundingClientRect().right;
    if (overflow > 0) this.element.scrollLeft += overflow + 24;
  }
}
